import {
    AUTOSHIP_UNIT_OF_MEASURE_BY_FREQUENCY_UNIT,
    getRecommendedAutoshipCadence,
    isFiveOrSevenWeekAutoshipCadence,
    type Product,
} from '@libs/common-types';

import type { FallbackFrequencyRecommendation, FrequencyRecommendation } from './frequencyRecommendation';

const DEFAULT_FALLBACK_FREQUENCY: FallbackFrequencyRecommendation = {
    source: 'fallback',
    recommendedAutoshipFrequency: 4,
    frequencyUnit: 'weeks',
};

type CatalogRecommendedFrequency = Pick<
    Product,
    'recommendedAutoshipFrequency' | 'recommendedAutoshipFrequencyUnitOfMeasure'
>;

export const resolveFallbackFrequency = (
    product?: CatalogRecommendedFrequency | null,
    as_freq_5_7 = false
): FallbackFrequencyRecommendation => {
    const cadence = getRecommendedAutoshipCadence(
        product?.recommendedAutoshipFrequency,
        product?.recommendedAutoshipFrequencyUnitOfMeasure,
        as_freq_5_7
    );

    if (!cadence) return DEFAULT_FALLBACK_FREQUENCY;

    return {
        source: 'fallback',
        recommendedAutoshipFrequency: Number(
            cadence.frequency
        ) as FallbackFrequencyRecommendation['recommendedAutoshipFrequency'],
        frequencyUnit: cadence.frequencyUnit,
    };
};

export const isHiddenFiveOrSevenWeekRecommendation = (
    recommendation: Pick<FrequencyRecommendation, 'recommendedAutoshipFrequency' | 'frequencyUnit'>,
    as_freq_5_7 = false
): boolean => {
    if (as_freq_5_7) return false;

    const unit = AUTOSHIP_UNIT_OF_MEASURE_BY_FREQUENCY_UNIT[recommendation.frequencyUnit];
    return isFiveOrSevenWeekAutoshipCadence(`${recommendation.recommendedAutoshipFrequency}_${unit}`);
};

export const toVisibleFrequencyRecommendation = (
    recommendation: FrequencyRecommendation,
    product?: CatalogRecommendedFrequency | null,
    as_freq_5_7 = false
): FrequencyRecommendation => {
    if (!isHiddenFiveOrSevenWeekRecommendation(recommendation, as_freq_5_7)) {
        return recommendation;
    }

    return resolveFallbackFrequency(product, as_freq_5_7);
};
